<template>
    <ModalBase modal-type="info" @close="$emit('close')">
        <template #header>

            <slot name="header"></slot>

        </template>
        <template #body>
            <div class="text-center">
                <slot name="body"></slot>
            </div>
        </template>
        <template #footer>
                <button @click="$emit('close')" class="font-bold bg-blue-500 text-white px-4 py-1 float-right mt-4 w-1/2 m-auto">Ok
                </button>
        </template>
    </ModalBase>
</template>
<script>
    import ModalBase from "@/components/shared/ModalBase";

    export default {
        name: 'InformationModal',
        components: {
            ModalBase,
        }
    }
</script>
<style scoped>

</style>